import { useState, useCallback } from 'react';

interface DayListItem {
  time: number;
  text: string;
}

export default function OrderCenterSameCityUseCarTime() {
  const [finalTime, setFinalTime] = useState<number>(0); // 最终选择时间戳
  const [rightNow, setRightNow] = useState<boolean>(false); // 是否选择现在
  const [hours, setHours] = useState<number>(0); // 小时选择
  const [days, setDays] = useState<number>(0); // 日期选择
  const [mins, setMins] = useState<number>(0); // 分钟选择
  const [dayList, setDayList] = useState<DayListItem[]>([]); // 日期列表
  const [hourList, setHourList] = useState<string[]>([]); // 小时列表
  const [minList, setMinList] = useState<string[]>([]); // 分钟列表
  const [timeStep, setStep] = useState<10 | 30>(10); // 用车时间间隔
  // 2023-12-18 和app同步确认大小车起始间隔时间都固定为10分钟(原小车30 大车10)
  const startLimit = 10;
  const [resetSign, setResetSign] = useState<number>(0);
  const [preStepTime, setPreStepTime] = useState<number>(0); // 上一步时确认订单页时间
  const setDaysCb = useCallback((val) => {
    setDays(val);
  }, []);
  const setHoursCb = useCallback((val) => {
    setHours(val);
  }, []);
  const setMinsCb = useCallback((val) => {
    setMins(val);
  }, []);
  const setDayListCb = useCallback((val) => {
    setDayList(val);
  }, []);
  const setHourListCb = useCallback((val) => {
    setHourList(val);
  }, []);
  const setMinListCb = useCallback((val) => {
    setMinList(val);
  }, []);
  const setStepCb = useCallback((val) => {
    setStep(val);
  }, []);

  const setFinalTimeCb = useCallback((val) => {
    setFinalTime(val);
  }, []);

  const setRightNowCb = useCallback((val) => {
    setRightNow(val);
  }, []);

  const setPreStepTimeCb = useCallback((val) => {
    setPreStepTime(val);
  }, []);
  const reset = useCallback(() => {
    setResetSign(resetSign + 1);
  }, [resetSign]);

  return {
    mins,
    setMinsCb,
    days,
    setDaysCb,
    hours,
    setHoursCb,
    finalTime,
    setFinalTimeCb,
    rightNow,
    setRightNowCb,
    dayList,
    setDayListCb,
    hourList,
    setHourListCb,
    minList,
    setMinListCb,
    timeStep,
    setStepCb,
    startLimit,
    resetSign,
    reset,
    preStepTime,
    setPreStepTimeCb,
  };
}
